import notificationApi from "@/api/notificationApi";
import { defineStore } from "pinia";

export const useNotificationStore = defineStore(`${process.env.VUE_APP_NAME}_notificationStore`, {
  id: "notification",
  state: () => ({
    notifications: [],
    unreadCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
  }),
  actions: {
    async registerToken(token) {
      try {
        const userId = this.getUserId();
        if (userId) {
          await notificationApi.registerToken(token, userId);
          this.fcmToken = token;
        }
      } catch (error) {
        console.error("Error registering FCM token:", error);
      }
    },
    getUserId() {
      const user = JSON.parse(localStorage.getItem(`${process.env.VUE_APP_NAME}_user`));
      return user ? user.id : null;
    },
    async fetchNotifications(pageNumber = 1, pageSize = 50) {
      try {
        const userId = this.getUserId();
        const pagedResult = await notificationApi.getNotifications(
          userId,
          pageNumber,
          pageSize
        );
        this.notifications = pagedResult.items;
        this.totalCount = pagedResult.totalCount;
        this.pageNumber = pagedResult.pageNumber;
        this.pageSize = pagedResult.pageSize;
        this.unreadCount = pagedResult.totalUnreadCount;
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    },
    async markAsRead(notificationId) {
      const notification = this.notifications.find(
        (n) => n.id === notificationId
      );
      if (notification && !notification.isRead) {
        notification.isRead = true;
        this.unreadCount--;
        try {
          await notificationApi.markAsRead(notificationId);
        } catch (error) {
          console.error("Error marking notification as read:", error);
        }
      }
    },
    async markAllAsRead() {
      try {
        await notificationApi.markAllAsRead(this.getUserId());
        this.notifications.forEach((n) => (n.isRead = true));
        this.unreadCount = 0;
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
      }
    },
    async fetchUnreadCount() {
      try {
        const userId = this.getUserId();
        this.unreadCount = await notificationApi.getUnreadCount(userId);
      } catch (error) {
        console.error("Error fetching unread count:", error);
      }
    },
    getNotificationLink(notification) {
      switch (notification.typeInString) {
        case "Ticket_Create":
        case "Ticket_Update":
        case "Ticket_Transition":
        case "Ticket_Assignment":
          return `/ticket-action/edit/${notification.relatedObjectId}/pageconfig1?layoutId=1&pageConfigId=1`;
        default:
          return "#";
      }
    },
  },
});
